<!-- eslint-disable @typescript-eslint/no-use-before-define -->
<template>
    <div id="pageContainer">
        <div class="content-cards" @scroll="handleScroll">
            <div
                class="cards-item"
                v-for="(item, index) in items"
                :key="item.Id"
                :style="{
                    backgroundColor: item.IsHidden == '1' ? '#f5f5f5' : '#fff',
                }"
            >
                <span class="fan-num">{{ index + 1 }}</span>
                <div class="item-left">
                    <img :src="item.photo" alt="" />
                </div>
                <div class="item-right">
                    <div class="__header">
                        <div
                            class="__toggle"
                            @click="toggleVisible(item)"
                            v-if="
                                item.realPlatform == 'PT001' ||
                                item.realPlatform == 'PT002' ||
                                item.realPlatform == 'PT005'
                            "
                        >
                            <img
                                :src="
                                    item.IsHidden == '0'
                                        ? require('@/static/images/icon/eye.png')
                                        : require('@/static/images/icon/eye-off.png')
                                "
                                class="icon-img"
                            />
                        </div>
                        <div
                            :class="
                                item.PubState
                                    ? item.PubState === '测试'
                                        ? 'badge badge-test'
                                        : 'badge badge-prod'
                                    : ''
                            "
                        >
                            {{ item.PubState }}
                        </div>
                        <div class="__deployType">
                            {{ item.realPlatformName }}
                        </div>
                        <div class="__local">
                            {{ item.deployType }}
                        </div>
                        <div class="__status">
                            {{ item.shareType }}
                        </div>
                    </div>

                    <div class="__title">
                        {{ item.ProcessID }}
                    </div>
                    <div class="__content">
                        {{ item.ProcessName }}
                    </div>
                    <div class="__label">机器人:{{ item.RobotName }}</div>
                    <div class="__status">
                        状态:
                        <span
                            class="status"
                            :class="
                                item.RunStatus === '运行中'
                                    ? 'status-running'
                                    : 'status-idle'
                            "
                        >
                            {{ item.RunStatus }}
                        </span>
                    </div>
                    <div class="__bottom">
                        <div title="开发者">@{{ item.CreateMan }}</div>
                        <div title="累计执行次数（所有人）">
                            <svg
                                t="1765937449042"
                                class="icon"
                                viewBox="0 0 1024 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                p-id="35589"
                                width="12"
                                height="12"
                            >
                                <path
                                    d="M144.06514 817.808918l769.31546 0 0 63.513546-769.31546 0 0-63.513546Z"
                                    fill="#CCCCCC"
                                    p-id="35590"
                                ></path>
                                <path
                                    d="M143.416364 109.250216l63.557548 0 0 764.188696-63.557548 0 0-764.188696Z"
                                    fill="#CCCCCC"
                                    p-id="35591"
                                ></path>
                                <path
                                    d="M492.728074 197.891046l63.557548 0 0 586.90499-63.557548 0 0-586.90499Z"
                                    fill="#CCCCCC"
                                    p-id="35592"
                                ></path>
                                <path
                                    d="M684.330904 347.398128l63.557548 0 0 437.397908-63.557548 0 0-437.397908Z"
                                    fill="#CCCCCC"
                                    p-id="35593"
                                ></path>
                                <path
                                    d="M301.254182 495.28634l63.557548 0 0 289.509696-63.557548 0 0-289.509696Z"
                                    fill="#CCCCCC"
                                    p-id="35594"
                                ></path>
                            </svg>
                            {{ item.useTimes }}
                        </div>

                        <div title="上岗时间">
                            <svg
                                t="1765937375819"
                                class="icon"
                                viewBox="0 0 1024 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                p-id="27704"
                                width="12"
                                height="12"
                            >
                                <path
                                    d="M512 42.666667c259.2 0 469.333333 210.133333 469.333333 469.333333s-210.133333 469.333333-469.333333 469.333333S42.666667 771.2 42.666667 512 252.8 42.666667 512 42.666667z m0 85.333333a384 384 0 1 0 0 768 384 384 0 0 0 0-768z"
                                    fill="#C2C5CC"
                                    p-id="27705"
                                ></path>
                                <path
                                    d="M512 256a42.666667 42.666667 0 0 1 42.666667 42.666667v256a42.666667 42.666667 0 0 1-85.333334 0V298.666667a42.666667 42.666667 0 0 1 42.666667-42.666667z"
                                    fill="#C2C5CC"
                                    p-id="27706"
                                ></path>
                                <path
                                    d="M768 512m0 42.666667l0 0q0 42.666667-42.666667 42.666666l-213.333333 0q-42.666667 0-42.666667-42.666666l0 0q0-42.666667 42.666667-42.666667l213.333333 0q42.666667 0 42.666667 42.666667Z"
                                    fill="#C2C5CC"
                                    p-id="27707"
                                ></path></svg
                            >{{ item.AuditTime }}
                        </div>
                        <div
                            title="排序"
                            v-if="
                                item.realPlatform == 'PT001' ||
                                item.realPlatform == 'PT002' ||
                                item.realPlatform == 'PT005'
                            "
                        >
                            <svg
                                t="1768273934486"
                                class="icon"
                                viewBox="0 0 1024 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                p-id="6892"
                                width="12"
                                height="12"
                            >
                                <path
                                    d="M449.92 101.888a38.4 38.4 0 0 1 60.16 0l225.28 283.84a38.4 38.4 0 0 1-30.08 62.272H254.72a38.4 38.4 0 0 1-30.08-62.272l225.28-283.84z"
                                    fill="#5089F6"
                                    p-id="6893"
                                ></path>
                                <path
                                    d="M449.92 922.112a38.4 38.4 0 0 0 60.16 0l225.28-283.84A38.4 38.4 0 0 0 705.28 576H254.72a38.4 38.4 0 0 0-30.08 62.272l225.28 283.84z"
                                    fill="#C2C7CC"
                                    p-id="6894"
                                ></path>
                            </svg>
                            {{ item.seq }}
                        </div>
                    </div>
                    <div class="icon-btn-group">
                        <div
                            v-for="act in actions"
                            :key="act.key"
                            class="icon-btn"
                            :title="act.title"
                            :class="{
                                disabled:
                                    item.RunStatus != '空闲中' &&
                                    act.key == 'run',
                            }"
                            @click="
                                () => {
                                    if (
                                        item.RunStatus == '空闲中' &&
                                        act.key == 'run'
                                    ) {
                                        act.onClick(item);
                                        return;
                                    }
                                    if (act.key != 'run') {
                                        act.onClick(item);
                                        return;
                                    }
                                }
                            "
                        >
                            <img
                                v-if="
                                    act.key == 'run' &&
                                    (item.realPlatform == 'PT003' ||
                                        item.realPlatform == 'PT004')
                                "
                                :src="act.jumpIcon"
                                :alt="act.title"
                            />
                            <img
                                v-else-if="
                                    act.key == 'run' &&
                                    (item.realPlatform == 'PT001' ||
                                        item.realPlatform == 'PT002' ||
                                        item.realPlatform == 'PT005') &&
                                    item.RunStatus == '空闲中' &&
                                    item.deployType == '平台'
                                "
                                :src="act.icon"
                                :alt="act.title"
                            />
                            <img
                                v-else-if="
                                    act.key == 'run' &&
                                    (item.realPlatform == 'PT001' ||
                                        item.realPlatform == 'PT002' ||
                                        item.realPlatform == 'PT005') &&
                                    item.RunStatus != '空闲中'
                                "
                                :src="act.stopIcon"
                                :alt="act.title"
                            />
                            <img
                                v-else-if="
                                    act.key == 'run' &&
                                    (item.realPlatform == 'PT006' ||
                                        item.realPlatform == 'PT005') &&
                                    item.RunStatus == '空闲中' &&
                                    item.deployType == '本地'
                                "
                                :src="act.runIconLocal"
                                :alt="act.title"
                            />
                            <img
                                v-else-if="act.key != 'run'"
                                :src="act.icon"
                                :alt="act.title"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 加载更多提示 -->
        <div class="load-more" ref="loadMoreRef" v-if="props.loadMore">
            <span v-if="loadMore === 'pending'" @click="loadMoreData"
                >--- 加载更多 ---</span
            >
            <span v-else-if="loadMore === 'loading'">--- 正在加载 ---</span>
            <span v-else-if="loadMore === 'nomore'">已经到底了~ </span>
        </div>
    </div>

    <runlog ref="runlogRef" />
    <runlogPython ref="runlogpythonRef" />
    <dempSetup ref="dempSetupRef" @flashData="loadMoreData" />
    <dempotherSetup ref="dempotherSetupRef" @flashData="loadMoreData" />
    <dempPythonSetup ref="dempPythonSetupRef" @flashData="loadMoreData" />
</template>

<script setup>
import {
    ref,
    onMounted,
    onUnmounted,
    defineProps,
    watch,
    getCurrentInstance,
    defineEmits,
} from "vue";

import Qs from "qs";
import { VXETable } from "vxe-table";
import runIcon from "@/static/images/icon/play.png";
import settingIcon from "@/static/images/icon/setting.png";
import logIcon from "@/static/images/icon/log.png";
import jumpIcon from "@/static/images/icon/jump.png";
import stopIcon from "@/static/images/icon/stop.png";
import runIconLocal from "@/static/images/icon/localplay.png";
import runlog from "./runlog.vue";
import dempSetup from "./dempSetup.vue";
import dempotherSetup from "./dempotherSetup.vue";
import runlogPython from "./runlogPython.vue";
import dempPythonSetup from "./demppythonSetup.vue";
const { proxy } = getCurrentInstance();
const emit = defineEmits(["openEditComponent", "openDetailComponent"]);
const props = defineProps({
    loadMore: {
        type: Boolean,
        default: false,
    },
    searchStr: {
        type: String,
        default: "",
    },
    classType: {
        type: String,
        default: "",
    },
    shareType: {
        type: String,
        default: "",
    },
});

const items = ref([]); // 数据列表
const loadMore = ref("loading"); // 加载状态：pending/loading/nomore
const page = ref(1); // 当前页码
const pageSize = 200; // 每页数据量
const totalItems = ref(0); // 总数据量（模拟）
const loadMoreRef = ref(null); // 加载更多元素的引用
const runlogRef = ref(null);
const dempSetupRef = ref(null);
const dempotherSetupRef = ref(null);
const dempPythonSetupRef = ref(null);
const runlogpythonRef = ref(null);

const run = (item) => {
    console.log(item);
    if (item.realPlatform == "PT001" || item.realPlatform == "PT002") {
        playProcess(item.Id, item);
    } else if (item.realPlatform == "PT003") {
        //dify
        if (item.otherPlatform) {
            // 执行日志接口
            addDigitalEmpLogsApi({
                PubID: item.Id,
                UserID: proxy.$store.state.userID,
                Type: "1",
            });
            window.open(item.otherPlatform, "_blank");
        }
    } else if (item.realPlatform == "PT004") {
        // outsystems
        // 执行日志接口
        addDigitalEmpLogsApi({
            PubID: item.Id,
            UserID: proxy.$store.state.userID,
            Type: "1",
        });
        window.open(item.otherPlatform, "_blank");
    } else if (item.realPlatform == "PT005" && item.deployType == "平台") {
        // python
        playProcessPython(item.Id, item);
    } else if (
        ["PT005", "PT006"].includes(item.realPlatform) &&
        item.deployType == "本地"
    ) {
        if (item.localAppPath === "") {
            VXETable.modal.message({
                content: "本地应用路径为空！",
                status: "error",
            });
            return;
        }
        execLocalFile(item.ProcessID, item.ProcessName, item.localExeParam);
    }
};
const execLocalFile = async (ProcessID, ProcessName, localExeParam) => {
    const type = await VXETable.modal.confirm("您确定要运行该流程吗?");
    if (type === "confirm") {
        let safeProtocolName = "coe" + ProcessID;
        const params = localExeParam;
        if (!ProcessID?.trim()) {
            VXETable.modal.message({
                content: "请输入协议名称！",
                status: "error",
            });
            return;
        }
        const link =
            localExeParam != ""
                ? `${safeProtocolName}://${params || ""}`
                : `${safeProtocolName}://`;
        const a = document.createElement("a");
        a.href = link;
        a.click();
        addJobsLocal(ProcessID, ProcessName);
    }
};
const addJobsLocal = (processID, processName) => {
    const params = {
        ProcessID: processID,
        ProcessName: processName,
        CreatorUserId: proxy.$store.state.email,
    };
    proxy.$api.dEmpAPI
        .addJobLocal(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
const toggleVisible = (item) => {
    item.IsHidden = item.IsHidden == "1" ? "0" : "1";
    if (item.realPlatform == "PT001" || item.realPlatform == "PT002") {
        const params = {
            Id: item.Id,
            ProcessID: "",
            ProcessName: "",
            IsHidden: item.IsHidden,
            photo: "",
            seq: 0,
        };

        proxy.$api.jobManageAPI
            .setRobotHidden(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success === false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                console.log(res);
            })
            .catch((error) => {
                VXETable.modal.message({ content: error, status: "error" });
                console.log(error);
            });

        //python
    } else if (item.realPlatform == "PT005") {
        const paramsPython = {
            id: item.Id,
            projectID: "",
            projectName: "",
            IsHidden: item.IsHidden,
            Photo: "",
            seq: 0,
        };
        proxy.$api.jobManageAPI
            .setPythonRobotHidden(Qs.stringify(paramsPython))
            .then((res) => {
                if (res.data.Success === false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                console.log(res);
            })
            .catch((error) => {
                VXETable.modal.message({ content: error, status: "error" });
                console.log(error);
            });
    }
};
const setting = (item) => {
    if (item.realPlatform == "PT001" || item.realPlatform == "PT002") {
        proxy.$refs.dempSetupRef.showSetting(item);
    } else if (item.realPlatform == "PT005") {
        proxy.$refs.dempPythonSetupRef.showSetting(item);
    } else {
        proxy.$refs.dempotherSetupRef.showSetting(item);
    }
};

const log = (item) => {
    if (item.realPlatform == "PT001" || item.realPlatform == "PT002") {
        proxy.$refs.runlogRef.findDataJob(item.ProcessID, item.RobotName, true);
    } else if (item.realPlatform == "PT005") {
        proxy.$refs.runlogpythonRef.findDataJob(
            item.ProcessID,
            item.RobotName,
            true
        );
    } else {
        VXETable.modal.message({
            content: "该平台暂无执行日志",
            status: "warning",
        });
    }
};

const actions = [
    {
        key: "run",
        title: "执行",
        icon: runIcon,
        jumpIcon: jumpIcon,
        stopIcon: stopIcon,
        runIconLocal: runIconLocal,
        onClick: run,
    },
    {
        key: "setting",
        title: "设置",
        icon: settingIcon,
        onClick: setting,
    },
    {
        key: "delete",
        title: "日志",
        icon: logIcon,
        onClick: log,
    },
];
// 模拟异步加载数据
const fetchData = () => {
    return new Promise((resolve) => {
        const params = {
            uid: proxy.$store.state.userID,
            email: "",
            currentPage: page.value,
            pageSize: pageSize,
            searchKey: [props.classType, props.searchStr, props.shareType], // ['类别名称','按查询名称搜索']
        };
        console.log("fetchData params", params);
        proxy.$api.dEmpAPI.getDEmpList(Qs.stringify(params)).then((res) => {
            console.log("cardsSetDEmpList", res.data.Data);
            if (res.data.Success) {
                const data = res.data.Data.dataTable.all;
                totalItems.value = res.data.Data.totalResult;
                resolve(data);
            }
        });
    });
};
// 刷新数据,刷新状态
const freshData = async () => {
    // eslint-disable-next-line curly
    console.log("freshData");

    try {
        loadMore.value = "loading";
        const newData = await fetchData();
        page.value = 1; // 重置页码
        items.value = []; // 清空数据
        items.value = newData;
        loadMore.value = "nomore";
    } catch (error) {
        console.error("加载失败:", error);
        loadMore.value = "nomore";
    }
};

// 执行日志接口 addDigitalEmpLogs
const addDigitalEmpLogsApi = (params) => {
    proxy.$api.dashboardAPI
        .addDigitalEmpLogs(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success) {
                console.log("执行日志添加成功");
            } else {
                console.log("执行日志添加失败");
            }
        });
};
const playProcess = async (pId, item) => {
    const type = await VXETable.modal.confirm("您确定要运行该流程吗?");
    if (type === "confirm") {
        const params = {
            uid: proxy.$store.state.userID,
            email: proxy.$store.state.email,
            actionType: "1",
            actionKey: [pId, proxy.$store.state.userName],
        };
        proxy.$api.jobManageAPI
            .startProcess(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                // console.log(res.data.Data);
                VXETable.modal.message({
                    content: "流程已提交执行,请勿重复操作!",
                    status: "warning",
                });
                item.RunStatus = "排队中";
            })
            .catch((error) => {
                console.log(error);
            });
    }
};
const playProcessPython = async (pId, item) => {
    const type = await VXETable.modal.confirm("您确定要运行该流程吗?");
    if (type === "confirm") {
        const params = {
            uid: proxy.$store.state.userID,
            email: proxy.$store.state.email,
            actionType: "1",
            actionKey: [pId, proxy.$store.state.userName],
        };
        proxy.$api.jobManageAPI
            .startProcessPython(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                // console.log(res.data.Data);
                VXETable.modal.message({
                    content: "Python流程已提交执行,请勿重复操作!",
                    status: "warning",
                });
                item.RunStatus = "排队中";
            })
            .catch((error) => {
                console.log(error);
            });
    }
};

let timer = null;
const setTimer = () => {
    timer = setInterval(() => {
        freshData();
    }, 1000 * 10);
};
const clearTimer = () => {
    clearInterval(timer);
    timer = null;
};

onMounted(() => {
    setTimer();
});
onUnmounted(() => {
    if (timer) {
        console.log("market清除定时器");
        clearTimer();
    }
});

// 监听queryType变化，重新加载数据
watch(
    [() => props.classType, () => props.searchStr, () => props.shareType],
    async () => {
        console.log(
            "classType变化，重新加载数据",
            props.classType,
            props.searchStr,
            props.shareType
        );
        clearTimer();
        page.value = 1; // 重置页码
        items.value = []; // 清空数据
        loadMore.value = "loading"; // 重置加载状态

        setTimer();
    }
);
</script>

<style lang="scss" scoped>
@import "cardcss.scss";
</style>
